/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  DialogContentText,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PrecisionManufacturingOutlinedIcon from "@mui/icons-material/PrecisionManufacturingOutlined";
import { useEffect, useState, useContext } from "react";
import { getAnteojo } from "../../../project/services/GestionAtencionService";
import { DataGrid } from "@mui/x-data-grid";
import { gcConfirmaAProduccion } from "../../../project/services/GestionAtencionService";
import WaitingDialog from "../../utils/WaitingDialog";
import AuthContext from "../../contexts/AuthContext";

//
// ###########################################################################
//
const AnteojoEstadoDialog = ({ onClose, idGestionAtencionAnteojo, setMessage, setShowMessage }) => {
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [anteojo, setAnteojo] = useState({});
  const [anteojoTratamientoRows, setAnteojoTratamientoRows] = useState([]);
  const [anteojoEstadoRows, setAnteojoEstadoRows] = useState([]);
  const [openDialogConfirmaProduccion, setOpenDialogConfirmaProduccion] = useState(false);

  const { hasPermission } = useContext(AuthContext);
  const _confirmarProduccionGestionAtencion = hasPermission("anteojo-arreglo-confirma-produccion");

  const tableColumnsTratamiento = [
    {
      field: "ojo",
      headerName: "Ojo",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.ojo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "codigo_articulo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_articulo",
      headerName: "Tratamiento",
      headerAlign: "center",
      align: "left",
      flex: 4,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_tr_tipo",
      headerName: "Tipo",
      headerAlign: "center",
      align: "left",
      flex: 2,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_tr_tipo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_tr_marca",
      headerName: "Marca",
      headerAlign: "center",
      align: "left",
      flex: 2,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_tr_marca;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "tiempo_produccion",
      headerName: "Tiempo Producción",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.tiempo_produccion ? params.row.tiempo_produccion + " DÍAS" : "";
        return _val;
      },
    },
  ];

  const tableColumnsEstado = [
    {
      field: "descripcion_corta_area",
      headerName: "Área",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_corta_area;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "estado_short",
      headerName: "Estado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.estado_short;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "accion_short",
      headerName: "Acción",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.accion_short;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cambio_articulo",
      headerName: "Cambio",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cambio_articulo ? "CAMBIO" : "";
        return _val;
      },
    },
    {
      field: "detalle",
      headerName: "Detalle",
      headerAlign: "center",
      align: "left",
      flex: 4,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.detalle;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "observaciones",
      headerName: "Observaciones",
      headerAlign: "center",
      align: "left",
      flex: 2,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.observaciones;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "fecha_estado",
      headerName: "Fecha Estado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_estado;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "usuario_username",
      headerName: "Vend/Oper",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.usuario_username;
        _val = _val ? _val.toLowerCase() : "";
        return _val;
      },
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    const loadAnteojo = async () => {
      setIsDoingSomething(true);
      const response = await getAnteojo(idGestionAtencionAnteojo);
      setIsDoingSomething(false);

      if (response.ok) {
        let _anteojoObject = response.data.data.anteojo;

        _anteojoObject = {
          ..._anteojoObject,
          cristalOI:
            _anteojoObject.codigo_articulo_cristal_oi +
            " - " +
            _anteojoObject.modelo_articulo_cristal_oi,
          cristalOD:
            _anteojoObject.codigo_articulo_cristal_od +
            " - " +
            _anteojoObject.modelo_articulo_cristal_od,
          armazonAsol:
            _anteojoObject.codigo_articulo +
            " - " +
            _anteojoObject.descripcion_articulo +
            " - " +
            _anteojoObject.descripcion_ar_as_marca +
            " - " +
            _anteojoObject.modelo_articulo,
          clienteDejaSuAnteojo: _anteojoObject.cliente_deja_su_anteojo
            ? "CLIENTE DEJA SU ANTEOJO"
            : "",
          nombreApellidoCliente:
            _anteojoObject.nombre_cliente + " " + _anteojoObject.apellido_cliente,
          telefonosCliente:
            _anteojoObject.telefono_movil_cliente + " " + _anteojoObject.telefono_cliente,
          fechaNacimientoClienteEdad:
            _anteojoObject.fecha_nac_cliente + " - " + _anteojoObject.edad_cliente + " años",
          tipoDeAnteojo:
            _anteojoObject.tipo_anteojo === "monofocal-cerca"
              ? "Monofocal de cerca"
              : _anteojoObject.tipo_anteojo === "monofocal-lejos"
                ? "Monofocal de lejos"
                : _anteojoObject.tipo_anteojo === "monofocal-intermedia"
                  ? "Monofocal intermedia"
                  : _anteojoObject.tipo_anteojo === "bifocal"
                    ? "Bifocal"
                    : _anteojoObject.tipo_anteojo === "multifocal"
                      ? "Multifocal"
                      : _anteojoObject.tipo_anteojo === "ocupacional"
                        ? "Ocupacional"
                        : "",
        };

        setAnteojo(_anteojoObject);
        let _anteojoTratamientoList = response.data.data.anteojo.gc_anteojo_tratamiento_list.map((item) => {
          return {
            ...item,
            id: item.id_gc_anteojo_tratamiento,
          };
        });
        setAnteojoTratamientoRows(_anteojoTratamientoList);
        let _anteojoEstadoRows = response.data.data.gc_anteojo_arreglo_estado_list;
        setAnteojoEstadoRows(_anteojoEstadoRows.filter((item) => item.accion_code !== "asigna-bandeja" && item.accion_code !== "libera-bandeja"));
      } else {
        setMessage({
          severity: response.messageSeverity,
          messageText: response.messageText,
        });
        setShowMessage(true);
        return;
      }
    };
    loadAnteojo();
  }, []);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleCloseDialogConfirmaProduccion = (parConfirmaProduccion) => {
    parConfirmaProduccion =
      typeof parConfirmaProduccion == "boolean" ? parConfirmaProduccion : false;

    if (parConfirmaProduccion) {
      confirmaAProduccion(idGestionAtencionAnteojo);
    }

    setOpenDialogConfirmaProduccion(false);
  };
  //
  // ################################################################################
  //
  const confirmaAProduccion = async (parIdGestionAtencionAnteojo) => {
    setIsDoingSomething(true);
    const response = await gcConfirmaAProduccion("", parIdGestionAtencionAnteojo, "");
    setIsDoingSomething(false);

    if (response.ok) {
      onClose();
    }

    setMessage({
      severity: response.messageSeverity,
      messageText: response.messageText,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={handleCloseDialog}
        maxWidth={false}
        fullWidth={true}
        scroll="body"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Anteojo {anteojo.codigo_gc_anteojo}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography variant="subtitle1" gutterBottom>
                  Cliente
                </Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  id="nombreApellidoCliente"
                  label="Nombre y Apellido"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="nombreApellidoCliente"
                  value={anteojo.nombreApellidoCliente ? anteojo.nombreApellidoCliente : ""}
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  id="fechaNacimientoClienteEdad"
                  label="Fecha de nacimiento - Edad"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="fechaNacimientoClienteEdad"
                  value={
                    anteojo.fechaNacimientoClienteEdad ? anteojo.fechaNacimientoClienteEdad : ""
                  }
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  id="email"
                  label="email"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="email_cliente"
                  value={anteojo.email_cliente ? anteojo.email_cliente : ""}
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  id="telefonosCliente"
                  label="Teléfonos"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="telefonosCliente"
                  value={anteojo.telefonosCliente ? anteojo.telefonosCliente : ""}
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography variant="subtitle1" gutterBottom>
                  Cristales
                </Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12}>
                <TextField
                  id="tipoAnteojo"
                  label="Tipo de Anteojo"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="tipoDeAnteojo"
                  value={anteojo.tipoDeAnteojo ? anteojo.tipoDeAnteojo : ""}
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  id="cristalOI"
                  label="Cristal para ojo izquierdo"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="cristalOI"
                  value={anteojo.cristalOI ? anteojo.cristalOI : ""}
                  variant="outlined"
                  multiline
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  id="cristalOD"
                  label="Cristal para ojo derecho"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="cristalOD"
                  value={anteojo.cristalOD ? anteojo.cristalOD : ""}
                  variant="outlined"
                  multiline
                />
              </Grid>

              <Grid container spacing={2}>
                <Grid item sm={2}></Grid>
                <Grid item sm={2}></Grid>
                <Grid item sm={2}>
                  <Typography component="div" gutterBottom align="left">
                    Distancia pupilar
                  </Typography>
                </Grid>
                <Grid item sm={2}>
                  <Typography component="div" gutterBottom align="left">
                    Altura pupilar
                  </Typography>
                </Grid>
                <Grid item sm={2}>
                  <Typography component="div" gutterBottom align="left">
                    Altura párpado inferior
                  </Typography>
                </Grid>
                <Grid item sm={2}></Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item sm={2}></Grid>
                <Grid item sm={2}>
                  <Typography
                    component="div"
                    gutterBottom
                    align="center"
                    sx={{ fontWeight: "bold" }}
                  >
                    Ojo derecho
                  </Typography>
                </Grid>
                <Grid item sm={2}>
                  <TextField
                    id="distancia_pupilar_od"
                    size="small"
                    sx={{ width: "50%" }}
                    inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                    name="distancia_pupilar_od"
                    value={anteojo.distancia_pupilar_od}
                  />
                </Grid>
                <Grid item sm={2}>
                  <TextField
                    id="altura_pupilar_od"
                    size="small"
                    sx={{ width: "50%" }}
                    inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                    name="altura_pupilar_od"
                    value={anteojo.altura_pupilar_od}
                  />
                </Grid>
                <Grid item sm={2}>
                  <TextField
                    id="altura_parpado_inferior_od"
                    size="small"
                    sx={{ width: "50%" }}
                    inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                    name="altura_parpado_inferior_od"
                    value={anteojo.altura_parpado_inferior_od}
                  />
                </Grid>
                <Grid item sm={2}></Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item sm={2}></Grid>
                <Grid item sm={2}>
                  <Typography
                    component="div"
                    gutterBottom
                    align="center"
                    sx={{ fontWeight: "bold" }}
                  >
                    Ojo izquierdo
                  </Typography>
                </Grid>
                <Grid item sm={2}>
                  <TextField
                    id="distancia_pupilar_oi"
                    size="small"
                    sx={{ width: "50%" }}
                    inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                    name="distancia_pupilar_oi"
                    value={anteojo.distancia_pupilar_oi}
                  />
                </Grid>
                <Grid item sm={2}>
                  <TextField
                    id="altura_pupilar_oi"
                    size="small"
                    sx={{ width: "50%" }}
                    inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                    name="altura_pupilar_oi"
                    value={anteojo.altura_pupilar_oi}
                  />
                </Grid>
                <Grid item sm={2}>
                  <TextField
                    id="altura_parpado_inferior_oi"
                    size="small"
                    sx={{ width: "50%" }}
                    inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                    name="altura_parpado_inferior_oi"
                    value={anteojo.altura_parpado_inferior_oi}
                  />
                </Grid>
                <Grid item sm={2}></Grid>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography variant="subtitle1" gutterBottom>
                  Armazón / Anteojo de Sol
                </Typography>
              </Grid>
            </Grid>

            {anteojo.montura_nuevo_cliente === "nuevo" && (
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <TextField
                  id="armazonAsol"
                  label="Código - Descripción - Marca - Modelo"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="armazonAsol"
                  value={anteojo.armazonAsol}
                />
              </Grid>
            )}

            {anteojo.montura_nuevo_cliente === "cliente" && anteojo.cliente_deja_su_anteojo && (
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <TextField
                  id="cliente_deja_su_anteojo"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="cliente_deja_su_anteojo"
                  value={anteojo.clienteDejaSuAnteojo}
                />
              </Grid>
            )}

            {anteojo.montura_nuevo_cliente === "cliente" && !anteojo.cliente_deja_su_anteojo && (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Typography variant="overline" gutterBottom sx={{ fontWeight: "bold", color: "brown" }}>
                    EL CLIENTE NO DEJO SU ANTEOJO
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <TextField
                    id="estado_montura"
                    label="Estado de la montura"
                    size="small"
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                    name="estado_montura"
                    value={anteojo.estado_montura}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={2}>
                  <TextField
                    id="medida_horizontal"
                    label="Medida horizontal"
                    size="small"
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                    name="medida_horizontal"
                    value={anteojo.medida_horizontal}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={2}>
                  <TextField
                    id="medida_vertical"
                    label="Medida vertical"
                    size="small"
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                    name="medida_vertical"
                    value={anteojo.medida_vertical}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={2}>
                  <TextField
                    id="medida_diagonal"
                    label="Medida diagonal"
                    size="small"
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                    name="medida_diagonal"
                    value={anteojo.medida_diagonal}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={2}>
                  <TextField
                    id="medida_puente"
                    label="Medida puente"
                    size="small"
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                    name="medida_puente"
                    value={anteojo.medida_puente}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={2}>
                  <TextField
                    id="medida_mayor"
                    label="Medida mayor"
                    size="small"
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                    name="medida_mayor"
                    value={anteojo.medida_mayor}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <TextField
                    id="perfil"
                    label="Perfil"
                    size="small"
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                    name="perfil"
                    value={anteojo.perfil}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <TextField
                    id="caracteristica"
                    label="caracteristica"
                    size="small"
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                    name="caracteristica"
                    value={anteojo.caracteristica}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={2}>
                  <TextField
                    id="base"
                    label="base"
                    size="small"
                    sx={{ width: "100%" }}
                    inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                    name="base"
                    value={anteojo.base}
                  />
                </Grid>
              </Grid>
            )}
          </Box>

          {anteojoTratamientoRows.length > 0 && (
            <Box sx={{ border: "1px solid LightGrey", mb: 1, p: 1, borderRadius: "5px" }}>
              <Typography variant="subtitle1" sx={{ mt: 1, ml: 1 }}>
                Tratamientos
              </Typography>
              <DataGrid
                rows={anteojoTratamientoRows}
                columns={tableColumnsTratamiento}
                {...tableOptions}
              />
            </Box>
          )}

          {anteojo.observaciones_gc_anteojo && (
            <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    Notas y observaciones
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <TextField
                  id="observaciones_gc_anteojo"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="observaciones_gc_anteojo"
                  value={anteojo.observaciones_gc_anteojo}
                  multiline
                />
              </Grid>
            </Box>
          )}

          {anteojoEstadoRows.length > 0 && (
            <Box sx={{ border: "1px solid LightGrey", mb: 1, p: 1, borderRadius: "5px" }}>
              <Typography variant="subtitle1" sx={{ mt: 1, ml: 1 }}>
                Estados del Anteojo
              </Typography>
              <DataGrid
                rows={anteojoEstadoRows}
                columns={tableColumnsEstado}
                {...tableOptions}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Box sx={{ textAlign: "right", p: 1 }}>
            {anteojo.action_confirmar_para_produccion && _confirmarProduccionGestionAtencion && (
              <Button
                sx={{ mr: 1, backgroundColor: "warning" }}
                variant="contained"
                onClick={() => {
                  setOpenDialogConfirmaProduccion(true);
                }}
                startIcon={<PrecisionManufacturingOutlinedIcon />}
              >
                Confirmar para producción
              </Button>
            )}

            {anteojo.action_no_confirmar_para_produccion && (
              <Button
                sx={{ mr: 1, backgroundColor: "warning" }}
                variant="contained"
                // onClick={setOpenDialogNoConfirmaProduccion(true)}
                startIcon={<PrecisionManufacturingOutlinedIcon />}
              >
                No confirmar para producción
              </Button>
            )}
            <Button sx={{ mr: 1 }} variant="outlined" onClick={handleCloseDialog}>
              Cancelar
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* >>>> confirmation production dialog */}

      <Dialog
        open={openDialogConfirmaProduccion}
        onClose={handleCloseDialogConfirmaProduccion}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirmación a Producción"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Estás seguro que querés confirmar el envío a producción de este Anteojo?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseDialogConfirmaProduccion(true)}>
            Confirmar a Producción
          </Button>
          <Button onClick={() => handleCloseDialogConfirmaProduccion(false)} autoFocus>
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default AnteojoEstadoDialog;
